/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Eta_Less_Than_MinuteInputs */



/**
* | output |
* | --- |
* | "Less than a minute remaining" |
*
* @param {Activity_Eta_Less_Than_MinuteInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_eta_less_than_minute = /** @type {((inputs?: Activity_Eta_Less_Than_MinuteInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Eta_Less_Than_MinuteInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Weniger als eine Minute verbleibend")
	return /** @type {LocalizedString} */ ("Less than a minute remaining")
});